import { colors, spacing, measures, font } from 'styles/variables'
import { css } from '@emotion/core'

const { half, unit } = measures

export const paddings = {
  circle: {
    small: spacing(1),
    medium: spacing(2),
    large: spacing(4),
  },

  small: spacing(0.5, 2),
  medium: spacing(1.75, 2),
  large: spacing(2, 1.5),
}

export default {
  container: css`
    display: flex;
    justify-content: center;
    flex-direction: column;
  `,
  labelsContainer: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: ${unit}px;
    padding: 0 ${unit + half}px;
  `,
  label: css`
    color: ${colors.white100};
    font-family: ${font.family};
  `,
  secondLabel: css`
    * {
      color: ${colors.white60};
    }
    cursor: pointer;
  `,
  required: css`
    color: ${colors.greens.green6};
  `,
  inputContainer: css`
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    border: 1px solid ${colors.grays.gray7};
    border-radius: ${unit + half}px;
  `,
  inputGrayBg: css`
    background-color: ${colors.grays.gray8};
    border-color: transparent;
  `,
  inputContainerFocused: css`
    border-color: ${colors.greens.green6};
  `,
  togglePasswordButton: css`
    position: absolute;
    right: ${2 * unit}px;
    cursor: pointer;
  `,
  input: (size) => css`
    padding: ${paddings[size]};
    text-align: left;
    width: 100%;
    background-color: transparent;
    color: ${colors.grays.gray7};
    font-size: ${font.size11};
    border-radius: ${unit + half}px;

    ::placeholder {
      color: ${colors.white40};
    }

    :focus {
      outline: none;
      color: ${colors.greens.green7};
    }
    &:disabled {
      color: #6b6b6f;
      border-color: #6b6b6f;
    }
  `,
  inputSuccess: css`
    color: white;
  `,
  inputError: css`
    color: ${colors.errors.error3};
  `,
  errorMessage: css`
    color: ${colors.errors.error3};
    align-self: flex-end;
    font-size: ${font.size12};
    margin-top: ${half / 2}px;
    margin-right: ${unit + half}px;
    min-height: 1rem;
  `,
  inlineIcon: css`
    padding-left: ${spacing(2.5)};
    margin-top: ${half}px;
  `,
}
